// extracted by mini-css-extract-plugin
export default {"label":"Label_label__KgJlJ","bold":"Label_bold__fjt9o","italic":"Label_italic__LMqZB"};